var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Create a global variable "listingsInitialSate" for use when 
// restoring the listings to their begining state
const listingsInitialState = document.querySelector(".news-listings");
let listingsInitialStateHTML = "";
if (listingsInitialState != null) {
    listingsInitialStateHTML = listingsInitialState.innerHTML;
}
/**
 * To be run every time a request to populate the news listings is called to
 * handle the response data and population of the listings.
 * @param response The JSON response from the API call.
 */
function UpdateNewsListings(response) {
    ResetListingsComponent();
    PopulateNewsListings(response.listings);
    UpdateControlls(response.meta);
}
;
/**
 * Taking in an array of News Listings from the API response build out the news listing component cards.
 * @param listings An array of NewsResponseListing's for populating the news listing component container.
 */
function PopulateNewsListings(listings) {
    const templateListing = document.querySelector(".templates .news-card");
    if (templateListing != null) {
        // Create state to restore for the template to build out each card
        let templateBase = templateListing.innerHTML;
        // Loop through all the provided listings
        for (let i = 0; i < listings.length; i++) {
            let listing = listings[i];
            // Get the Template cards image
            let image = templateListing.querySelector(".news-card-image");
            if (image != null) {
                // Update image content
                image.innerHTML = image.innerHTML.replace('title', `${listing.imageName}`).replace('/', `${listing.imageUrl}`);
            }
            // Get the Template cards tags container
            let tags = templateListing.querySelector(".news-card-tags");
            if (tags != null) {
                let tagHtml = tags.querySelector(".tag");
                if (tagHtml != null) {
                    for (let j = 0; j < listing.tags.length; j++) {
                        // Update tag html to use correct content
                        tagHtml.innerHTML = tagHtml.innerHTML.replaceAll("tag", listing.tags[j]);
                        // Update tags container with new tag
                        if (j === 0) {
                            tags.innerHTML = tagHtml.outerHTML;
                        }
                        else {
                            tags.innerHTML += tagHtml.outerHTML;
                        }
                        // Reset tag html
                        tagHtml.innerHTML = tagHtml.innerHTML.replaceAll(listing.tags[j], "tag");
                    }
                }
            }
            // Get the Template cards date element
            let date = templateListing.querySelector(".news-card-date");
            let listingDate = new Date(Date.parse(listing.date)).toLocaleString("en-UK", { dateStyle: 'long' });
            if (date != null) {
                date.innerHTML = date.innerHTML.replace("date", listingDate);
            }
            // Get the Template cards title element
            let title = templateListing.querySelector(".news-card-title");
            if (title != null) {
                title.innerHTML = title.innerHTML.replace("title", listing.title);
            }
            // Get the Template cards description/ summary element
            let description = templateListing.querySelector(".news-card-description");
            if (description != null) {
                description.innerHTML = description.innerHTML.replace("description", listing.summary);
            }
            // Get the Template cards invisible link
            let invisibleLink = templateListing.querySelector(".invisible-cover-link");
            if (invisibleLink != null) {
                invisibleLink.href = listing.link.link.url;
            }
            // Update Listings page with created listing
            let newsCards = document.querySelector(".news-listings .news-cards");
            if (newsCards != null) {
                newsCards.innerHTML += templateListing.outerHTML;
            }
            // Reset template
            templateListing.innerHTML = templateBase;
        }
    }
}
;
/**
 * Updates and creates the pager toggles and page indicators for manipulating news listing content.
 * @param meta The meta data form the News API's response contianing paging information.
 */
function UpdateControlls(meta) {
    const listingControlls = document.querySelector(".news-listings .listing-pagers");
    if (listingControlls != null) {
        // Create and Initialise news listing page indicators
        const pages = listingControlls.querySelector(".listing-pages");
        CreatePagers(pages, meta);
        // Update functionality and states of news listing arrow pagers
        const togglers = listingControlls.querySelectorAll(".listing-toggler");
        UpdateTogglers(togglers, meta);
    }
}
;
/**
 * Create the page indicator components within the provided container as a
 * secondary method of requesting news listing pages.
 * @param container A HTMLElement for populating with news listing page indicators.
 * @param meta The meta data form the News API's response contianing paging information.
 */
function CreatePagers(container, meta) {
    const pagerBase = container.querySelector(".page-dot"); // find the Existing page indicator
    if (pagerBase != null) {
        let pagerHTML = pagerBase === null || pagerBase === void 0 ? void 0 : pagerBase.outerHTML; // Retrieve the page indicator html for manipulation
        for (let i = 0; i < meta.pages; i++) {
            if (i == 0) { // if I is 0 it is for the first indicator which already exists
                continue;
            }
            // create a new pager html and append it to the containers contents
            let newPager = pagerHTML.replaceAll("1", (i + 1).toString());
            container.innerHTML += newPager;
        }
        // Loop through all the created pagers and initialise their states and onclick functionality
        for (let i = 0; i < meta.pages; i++) {
            let pager = container.querySelector(`#page-${i + 1}`);
            InitialisePager(pager, meta);
        }
    }
}
;
/**
 * Updates the states and onclick events of the news pages indicators under the news listings.
 * @param pager The Page Indicator Element to be manipulated.
 * @param meta The meta data form the News API's response contianing paging information.
 */
function InitialisePager(pager, meta) {
    const pagerId = +pager.innerHTML;
    // If the page indicator is the current page being displayed
    if (pagerId === meta.currentPage) {
        pager.classList.add("focused");
    }
    else {
        pager.classList.remove("focused");
    }
    // Attach onclick listener to the page indicator where onclick make a request to show the designated page
    pager.onclick = function () {
        return __awaiter(this, void 0, void 0, function* () {
            // If the clicked page indicator is the current page don't do anything
            if (pager.classList.contains("focused")) {
                return;
            }
            // Updates the news listings on click
            const response = yield GetNewsPage(pagerId - 1, meta.pageSize);
            UpdateNewsListings(response);
        });
    };
}
;
/**
 * Updates the provided toggler elements enabled/ disabled states and onclick functionality.
 * @param togglers The Arrow Button Elements for paging through the news results.
 * @param meta The meta data form the News API's response contianing paging information.
 */
function UpdateTogglers(togglers, meta) {
    togglers.forEach(toggler => {
        UpdateTogglerState(toggler, meta);
        UpdateTogglerFunction(toggler, meta);
    });
}
;
/**
 * Update the states of the togger arrow elements as disabled or enabled.
 * @param toggler The Arrow Button Element for paging through the news results.
 * @param meta The meta data form the News API's response contianing paging information.
 */
function UpdateTogglerState(toggler, meta) {
    // different conditional logic for forward and backward arrows
    if (toggler.dataset.direction === "forward") {
        // if the current page is the last page
        if (meta.currentPage === meta.pages) {
            toggler.classList.add("disabled");
        }
        else {
            toggler.classList.remove("disabled");
        }
    }
    else {
        // if the current page is the first page
        if (meta.currentPage === 1) {
            toggler.classList.add("disabled");
        }
        else {
            toggler.classList.remove("disabled");
        }
    }
}
;
/**
 * Sets the onclick listeners for the toggler arrows for the news listing component.
 * @param toggler The Arrow Button Element for paging through the news results.
 * @param meta The meta data form the News API's response contianing paging information.
 */
function UpdateTogglerFunction(toggler, meta) {
    toggler.onclick = function () {
        return __awaiter(this, void 0, void 0, function* () {
            // If the arrow is disabled onclick does nothing
            if (toggler.classList.contains("disabled")) {
                return;
            }
            let response = null;
            // Retrieve the page data for the next or previous page
            if (toggler.dataset.direction === "forward") {
                response = yield GetNewsPage(meta.currentPage, meta.pageSize);
            }
            else {
                response = yield GetNewsPage(meta.currentPage - 2, meta.pageSize);
            }
            // Update the news listings HTML
            if (response != null) {
                UpdateNewsListings(response);
            }
        });
    };
}
;
/**
 * Resets the state of the news listing component to an empty state safe for population.
 */
function ResetListingsComponent() {
    if (listingsInitialState != null) {
        listingsInitialState.innerHTML = listingsInitialStateHTML;
    }
    InitialiseViewAllButton();
}
;
/**
 * If there is a news listing component "view all news" button, give it an onclick listener.
 */
function InitialiseViewAllButton() {
    const viewAllNewsButton = document.querySelector(".view-all-news");
    // If the button is a valid element
    if (viewAllNewsButton != null) {
        // Attach an onclick listener to populate the listings
        viewAllNewsButton.addEventListener("click", function () {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield GetNewsPage(0, 100, true); //100 is ther max size acceptable by the API
                UpdateNewsListings(response);
            });
        });
    }
}
;
/**
 * Makes a request to the News API Controller for some news listings.
 * @param page The page number of news listings to retrieve
 * @param pageSize The size of the page to be retrieved
 * @param viewAll A boolean value determining if all the news items should be returned
 * @returns the response JSON object returned by the API Controller
 */
function GetNewsPage() {
    return __awaiter(this, arguments, void 0, function* (page = 0, pageSize = 3, viewAll = false) {
        const newsUrl = location.pathname;
        const params = new URLSearchParams(window.location.search);
        let searchTerm = params.get("search");
        let filters = params.getAll("filter");
        let requestUrl = `/api/news?pageNumber=${page}&pageSize=${pageSize}&viewAll=${viewAll}`;
        requestUrl = `${requestUrl}&newsUrl=${encodeURIComponent(newsUrl)}`;
        if (searchTerm !== null && searchTerm !== "") {
            requestUrl = `${requestUrl}&searchTerm=${searchTerm}`;
        }
        if (filters.length > 0) {
            requestUrl = `${requestUrl}&filter=${filters.toString()}`;
        }
        const response = yield fetch(requestUrl, { method: "GET" });
        const responseJson = yield response.json();
        return responseJson;
    });
}
;
/**
 * Initialises the filter panel present within the News Root Pages Hero to share the content of any filters provided within the pages query string.
 */
function FilterPanelSetup() {
    // Get the query string data from the url 
    const urlParams = new URLSearchParams(window.location.search);
    const filterParam = urlParams.getAll("filter");
    const searchParam = urlParams.get("search");
    // Get the filter buttons from the page if present
    let filterButtons = document.querySelectorAll("input[name=filter]");
    // loop through the filter parameters updating the filter buttons states to match the present filters
    filterParam.forEach(filter => {
        filterButtons.forEach(button => {
            // Button matches the parameter toggle their checked state
            if (button.value.toLowerCase() === filter.toLowerCase()) {
                button.checked = true;
            }
        });
    });
    // Get the search field if present from the news root pages hero to update its contents to match the query string
    let searchField = document.querySelector("input[name=search]");
    if (searchParam !== null && searchField !== null) {
        searchField.value = searchParam;
    }
}
;
export class News {
    /**
     * When a page first loads attempt to initialise any news listing components with the first page of news.
     * @param pageSize The numerical size of the news pages.
     * @param viewAll An optional boolean for initialising the news listing component with all news items.
     */
    InitialiseReviewListings() {
        return __awaiter(this, arguments, void 0, function* (pageSize = 6, viewAll = false) {
            // If the news listing container exists on the page then proceed with making a request to the API
            if (document.querySelector(".news-listings .news-cards") != null && document.querySelector(".templates .news-card") != null) {
                const response = yield GetNewsPage(0, pageSize, viewAll);
                // Using the API response update the News Listings component
                UpdateNewsListings(response);
            }
            FilterPanelSetup();
        });
    }
    ;
}
